import { ThemeOptions } from '@mui/material'

export default (): ThemeOptions['components'] => ({
    MuiDatePicker: {
        defaultProps: {
            views: ['year', 'month'],
            readOnly: false, //we need to set readOnly to false for ATs
        },
    },
    MuiDateTimePicker: {
        defaultProps: {
            ampm: false,
            ampmInClock: true,
            format: 'DD MMM YYYY, HH:mm',
            disablePast: true,
        },
    },
    MuiDateTimePickerTabs: {
        defaultProps: {
            hidden: false,
        },
    },
})
